import { Stack } from '@mui/material';
import { useAtom } from 'jotai';

import CheckPermissions from '@/components/CheckPermissions';
import ContentNotification from '@/components/ContentNotfication';
import PERMISSIONS from '@/constants/auth.constants';
import PRODUCTS, { PRODUCT_SUB_TYPES } from '@/constants/products.constants';
import AssetDataProviderIntegration from '@/features/AdminAssetDataProviderIntegration';
import { AdminCanaryTokens } from '@/features/AdminCanaryTokens';
import MsDefenderIntegration from '@/features/AdminMsDefenderIntegration';
import { shouldShowMicrosoftIntegration } from '@/features/AdminMsDefenderIntegration/MsDefenderIntegration.utils';
import SecuritySnaresIntegration from '@/features/AdminSecuritySnaresIntegration';
import { WebhookConfiguration } from '@/features/AdminWebhookConfiguration';
import {
  useProductSubTypesCheck,
  useProductsCheck
} from '@/hooks/useProductsCheck';
import {
  useFetchSettings,
  useMutationSettings
} from '@/pages/Administration/Administration.store';
import type { SettingsTypes } from '@/pages/Administration/Administration.types';
import {
  orgProductsAtom,
  selectedOrganizationIdAtom
} from '@/pages/Organizations';

const AdministrationIntegrations = () => {
  const [selectedOrganizationId] = useAtom(selectedOrganizationIdAtom);
  const [orgProducts] = useAtom(orgProductsAtom);
  const { refetch, data: orgInfo } = useFetchSettings();
  const mutation = useMutationSettings(refetch);

  const handleSave = (updatedOrgInfo: SettingsTypes) => {
    mutation.mutate(updatedOrgInfo);
  };
  const hasEDR = useProductsCheck([PRODUCTS.EDR]);
  const hasRansomSnare = useProductSubTypesCheck([
    PRODUCT_SUB_TYPES.RANSOM_SNARE
  ]);
  const shouldShowMicrosoftCard = shouldShowMicrosoftIntegration(orgProducts);

  return (
    <>
      {selectedOrganizationId === 0 && (
        <ContentNotification
          title="Select an organization"
          text="Please select an organization to view and edit its integrations."
        />
      )}
      {selectedOrganizationId !== 0 && (
        <Stack spacing={2}>
          <CheckPermissions permissions={PERMISSIONS.INTERNAL}>
            <AssetDataProviderIntegration />
          </CheckPermissions>
          {/* TODO: remove permission check when Turbine is released */}
          {shouldShowMicrosoftCard && <MsDefenderIntegration />}
          {hasEDR && hasRansomSnare && (
            <SecuritySnaresIntegration orgInfo={orgInfo} />
          )}
          <WebhookConfiguration orgInfo={orgInfo} handleSave={handleSave} />
          {/* TODO: remove once asset data providers is fully released */}
          {/* <CheckProducts requiredProducts={[PRODUCTS.VMPE]}>
            <ShieldIntegration orgInfo={orgInfo} handleSave={handleSave} />
          </CheckProducts> */}
          <CheckPermissions permissions={PERMISSIONS.ADMIN_READ}>
            <AdminCanaryTokens />
          </CheckPermissions>
        </Stack>
      )}
    </>
  );
};

export default AdministrationIntegrations;
